const LENGTH_LIMIT = 127
const JOINER = ', '

const getListAndMore =
  (andMoreText: (count: number) => string) => (items: string[]) => {
    if (items.length <= 1) {
      return ''
    }
    const itemsWithQuotes = items.map(item => `«${item}»`)
    const andMoreLength = andMoreText(0).length
    const usedItems: string[] = []
    let usedItemsLength = andMoreLength
    for (const item of itemsWithQuotes) {
      const newLength = usedItemsLength + item.length
      if (newLength > LENGTH_LIMIT) {
        break
      }
      usedItems.push(item)
      usedItemsLength = newLength
    }
    if (usedItems.length === 0) {
      usedItems.push(
        `«${items[0].slice(0, LENGTH_LIMIT - andMoreLength - 2)}…»`
      )
    }
    const rest = itemsWithQuotes.length - usedItems.length
    return `${usedItems.join(JOINER)}${rest ? ` ${andMoreText(rest)}` : ''}`
  }

export const boardEn = {
  viewSettingsTitle: 'Display settings:',
  automationSettings: 'Automation settings:',

  timeTaskInCol: 'Time spent by tasks in columns',
  timeTaskInColNote: 'Display the time that tasks spent in columns.',

  countMsgInTask: 'Number of messages on task cards',
  showZeroMsgInTask: 'Display even if the task has no messages',
  autoCompleteTasks: 'Archive completed tasks',
  autoCompleteTasksHint:
    'Tasks will be automatically moved to the archive after completion. Tasks completed before the setting is enabled will not be moved to the archive',
  moveTaskToCol: `Move task to a column when done`,
  moveTaskToColHint:
    'Completed tasks will be automatically moved to the selected column',
  autoDoneTaskToCol: `Automatically execute the task when moving to a column`,
  autoDoneTaskToColHint:
    'Select one or more columns, when moving to which, tasks will be automatically executed',
  autoTaskCover: `Set the chat image as a cover`,
  autoTaskCoverHint:
    'The last image uploaded to the chat will become the task cover. The setting will not affect manually uploaded covers',
  listAndMore: getListAndMore((count: number) => `and ${count} more`),
  autoTaskCoverUpdate: 'Update',
  selectColumn: 'Select column',
  timeInColumn: 'Time in column',
  timeSpentInColumn: 'Time spent in columns',
  fullReport: 'Full Report',
  showReport: 'Go to report',
  showIdOnTaskCard: 'ID on task card'
}

export const boardRu: typeof boardEn = {
  viewSettingsTitle: 'Настройки отображения:',
  automationSettings: 'Настройки автоматизации:',

  timeTaskInCol: 'Время, которое задачи провели в колонках',
  timeTaskInColNote: 'Отображать время, которое задачи провели в колонках.',

  countMsgInTask: 'Количество сообщений на карточках задач',
  showZeroMsgInTask: 'Отображать, даже если у задачи нет сообщений',
  autoCompleteTasks: 'Архивировать выполненные задачи',
  autoCompleteTasksHint:
    'Задачи автоматически будут перенесены в архив после выполнения. Задачи, выполненные до включения настройки, не будут перемещены в архив',
  moveTaskToCol: `Переносить задачу в колонку при выполнении`,
  moveTaskToColHint:
    'Выполненные задачи будут автоматически перенесены в выбранную колонку',
  autoDoneTaskToCol: `Выполнять задачи при перемещении`,
  autoDoneTaskToColHint:
    'Выберите одну или несколько колонок, при переносе в которые, задачи будут автоматически выполняться',
  autoTaskCover: `Устанавливать картинку из чата в качестве обложки`,
  autoTaskCoverHint:
    'Последняя загруженная в чат картинка станет обложкой задачи. Настройка не затронет загруженные вручную обложки',
  listAndMore: getListAndMore((count: number) => `и еще ${count}`),
  autoTaskCoverUpdate: 'Обновить обложки',
  selectColumn: 'Выбрать колонку',
  timeInColumn: 'Время в колонке',
  timeSpentInColumn: 'Время, проведенное в колонках',
  fullReport: 'Полный отчёт',
  showReport: 'Перейти к отчету',
  showIdOnTaskCard: 'ID на карточке задачи'
}
